export const pageBodyPaddingInline = 20;
export const pageBodyPaddingBottom = 18;
